function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".code_svg__a{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}"));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "code_svg__a",
  d: "M14.081 12.626l5.606-5.606-5.606-5.606M6.606 1.414L1 7.02l5.606 5.606"
});

function SvgCode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20.688,
    height: 14.041,
    viewBox: "0 0 20.688 14.041"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMC42ODgiIGhlaWdodD0iMTQuMDQxIiB2aWV3Qm94PSIwIDAgMjAuNjg4IDE0LjA0MSI+PGRlZnM+PHN0eWxlPi5he2ZpbGw6bm9uZTtzdHJva2U6I2ZmZjtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46cm91bmQ7c3Ryb2tlLXdpZHRoOjJweDt9PC9zdHlsZT48L2RlZnM+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTIgLTcuNTg2KSI+PHBhdGggY2xhc3M9ImEiIGQ9Ik0yNCwyMC4yMTJsNS42MDYtNS42MDZMMjQsOSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTcuOTE5KSIvPjxwYXRoIGNsYXNzPSJhIiBkPSJNOC42MDYsOSwzLDE0LjYwNmw1LjYwNiw1LjYwNiIvPjwvZz48L3N2Zz4=";
export { SvgCode as ReactComponent };